<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 5.57076H17.1667M13.5435 0.5V4.12197M4.12319 0.5V4.12197M12.771 8.85951C13.1043 8.93775 13.3754 9.1797 13.4884 9.50423C13.5246 9.60709 13.5449 9.7143 13.5449 9.82296C13.5522 10.1692 13.3768 10.4937 13.0826 10.6792L7.39275 14.2113C7.27391 14.2852 7.12173 14.2809 7.00724 14.1998L4.92173 12.7365C4.83912 12.6698 4.82609 12.5481 4.89275 12.4655C4.90145 12.454 4.91304 12.4424 4.92463 12.4337L5.79999 11.6629C5.85217 11.6209 5.92319 11.6079 5.98695 11.631L7.08406 12.283L8.47536 11.3123L5.83767 9.68243C5.73767 9.59695 5.72463 9.44482 5.81159 9.34486C5.82318 9.33182 5.83623 9.31878 5.85072 9.30864L6.49565 8.83199C6.56087 8.78418 6.64638 8.77114 6.72174 8.80011L10.3594 10.1504L12.0406 9.00439C12.2551 8.85662 12.5203 8.80591 12.7754 8.86241L12.771 8.85951ZM1.22464 1.94879H16.442C16.442 1.94879 17.1667 1.94879 17.1667 2.67318V16.4367C17.1667 16.4367 17.1667 17.1611 16.442 17.1611H1.22464C1.22464 17.1611 0.5 17.1611 0.5 16.4367V2.67318C0.5 2.67318 0.5 1.94879 1.22464 1.94879Z"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
